__turbopack_context__.v({
  "Container": "ProfileSelection-module-scss-module__UimwRG__Container",
  "ErrorMessage": "ProfileSelection-module-scss-module__UimwRG__ErrorMessage",
  "Group": "ProfileSelection-module-scss-module__UimwRG__Group",
  "GroupLabel": "ProfileSelection-module-scss-module__UimwRG__GroupLabel",
  "OptionCard": "ProfileSelection-module-scss-module__UimwRG__OptionCard",
  "OptionChevron": "ProfileSelection-module-scss-module__UimwRG__OptionChevron",
  "OptionContent": "ProfileSelection-module-scss-module__UimwRG__OptionContent",
  "OptionMeta": "ProfileSelection-module-scss-module__UimwRG__OptionMeta",
  "OptionTitle": "ProfileSelection-module-scss-module__UimwRG__OptionTitle",
  "Subtitle": "ProfileSelection-module-scss-module__UimwRG__Subtitle",
  "Title": "ProfileSelection-module-scss-module__UimwRG__Title",
});
